import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Alert, Button, Classes, Dialog, FormGroup, InputGroup } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { IEmpresa, newEmpresa } from "../../model";
import { toast } from "react-toastify";
import IntlCurrencyInput from "react-intl-currency-input";
import { CaixaPostalStore } from "../../stores/caixa-postal/CaixaPostalStore";
import { BootstrapTable, TableHeaderColumn, SearchField } from "react-bootstrap-table";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj } from "../../utils";
import { AppStore } from "../../stores/AppStore";
import socket from "../../socket";
import LoadingModal from "../loading/LoadingModal";

const numeral = require("numeral");

@observer
export default class CaixaPostalAssunto extends React.Component<{}, {}> {

    obs = observable({
        open_buy_chave: false as boolean,
        quantidade: "" as string,
        valor_total: 0 as number,
        credito_restantes: 0 as number,
        count: 0 as number,
        pagamento_pix: false as boolean,
        listEmpresas: [] as any,
        open_erros_solicitacoes: false as boolean,
        erros_solicitacoes: [] as any,
    })

    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
    }

    thisValorCompra() {
        let valor_total = parseInt(this.obs.quantidade) * 0.24
        this.obs.valor_total = valor_total
        return (<>
            <MDBCol md="12">
                <div className="blocoAssin">
                    <span className="priceAssinPerfil"><b>R$</b> {numeral(valor_total).format("0,0.00")}</span>
                    <span className="descAssinPerfil">Total de chaves {numeral(this.obs.quantidade).format("0,0")}</span>
                </div>
            </MDBCol>
        </>)
    }

    async handleBuyChaves() {
        if (this.obs.quantidade == "") {
            toast.error("Insira uma quantidade!", {});
            return
        }

        if ((parseInt(this.obs.quantidade) * 0.24) < 1) {
            toast.error("O valor mínimo aceito é de R$ 1,00 (um real).", {});
            return
        }

        this.obs.open_buy_chave = false
        let quantidade = parseInt(this.obs.quantidade)
        let status = await CaixaPostalStore.handleBuyQuantidade(quantidade)

        if (status) {

            this.handleSocketPaid()
        }
    }

    handleSocketPaid() {
        this.obs.pagamento_pix = true

        let socket_paid = socket.channel("paid:" + AppStore.obs1.contaId);

        socket_paid.join()
            .receive("ok", resp => {
                console.log("Bem vindo 1", resp)
            })
            .receive("error", resp => {
                console.log("Error", resp)
            })

        socket_paid.on("paid", payload => {

            if (payload.body) {
                toast.success('Pagamento recebido com sucesso!');

                CaixaPostalStore.handleConsultaCredito()

                socket_paid.off("paid:" + AppStore.obs1.contaId)

                this.obs.pagamento_pix = false

            } else {
                toast.error('Nenhum pagamento encontrato!');

                this.obs.pagamento_pix = false

            }

        })

    }

    handleCancelPix() {
        CaixaPostalStore.obs.qrcode = ""
        CaixaPostalStore.obs.pix_id = ""
        this.obs.quantidade = ""
        this.obs.pagamento_pix = false
    }

    handleRowSelect = async (row, checked) => {
        if (checked) {
            this.obs.listEmpresas.push(row.cnpj_default);
        } else {
            let index = this.obs.listEmpresas.indexOf(row.cnpj_default);
            this.obs.listEmpresas.splice(index, 1);
        }
    };

    handleRowSelectAll = async (check, row) => {
        if (check) {
            this.obs.listEmpresas = row?.map(value => {
                return value.cnpj_default;
            });
        } else {
            this.obs.listEmpresas = [];
        }
    };

    createCustomSearchField = (props) => {
        return (
            <SearchField
                className="input-filter"
                defaultValue={props.defaultSearch}
                placeholder="Filtrar (Razão Social, Apelido, CNPJ)"
            />
        );
    };

    async handleSolicitaAssuntos() {
        if (this.obs.listEmpresas.length == 0) {
            toast.error("Selecione pelo menos uma Empresa!", {});
            return
        }

        let params = {
            cnpjs: this.obs.listEmpresas
        }

        let erros = await CaixaPostalStore.handleSolicitaAssuntos(params)
        await CaixaPostalStore.handleConsultaCredito()
        CaixaPostalStore.obs.loading_solicitacao = false

        if (erros.length > 0) {
            this.obs.open_erros_solicitacoes = true
            this.obs.erros_solicitacoes = []
            this.obs.erros_solicitacoes = erros
        }

        this.obs.listEmpresas = []
    }

    handleClose() {
        this.obs.listEmpresas = [];
    }

    render() {

        const currencyConfig = {
            locale: "pt-BR",
            formats: {
                number: {
                    BRL: {
                        style: "currency",
                        currency: "BRL",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    },
                },
            },
        };

        const getRestante = () => {
            this.obs.credito_restantes = CaixaPostalStore.obs.credito_contratado - CaixaPostalStore.obs.credito_usados
            return this.obs.credito_restantes
        }

        const selectRowProp = {
            mode: "checkbox",
            clickToSelect: true,
            columnWidth: "40px",
            onSelect: this.handleRowSelect,
            onSelectAll: this.handleRowSelectAll,
            isSelected: true,
            selected: this.obs.listEmpresas,
            bgColor: "rgba(27, 98, 111, 0.1)",
        };

        const options = {
            searchField: this.createCustomSearchField,
        };

        let select_empresas = EmpresaStore.sortedEmpresas?.filter(x => x["caixapostal_automatica"])?.map(map_emp => {

            let msg = CaixaPostalStore.obs.mensagens_pendentes.map(x => x["cnpj"]).includes(map_emp.cnpj)

            let emp = EmpresaStore.getByCnpj(map_emp.cnpj);
            if (emp) {
                if (emp.ativo) {
                    return (
                        {
                            _id: emp._id,
                            razao_social: emp.razao_social,
                            apelido: emp.apelido,
                            cnpj: formatCnpj(emp.cnpj),
                            cnpj_default: emp.cnpj,
                            mensagem: msg
                        }
                    )
                }
            }
        });

        let erros = this.obs.erros_solicitacoes?.map(map_emp => {
            let emp = EmpresaStore.getByCnpj(map_emp.cnpj);
            if (emp) {
                if (emp.ativo) {
                    return (
                        {
                            _id: emp._id,
                            razao_social: emp.razao_social,
                            erro: map_emp.erro,
                            cnpj: formatCnpj(emp.cnpj),
                        }
                    )
                }
            }
        });

        const formaterRazao = (cell, row) => {
            return cell.substring(0, 50)
        }

        const formatVisualizaMensagem = (cell, row) => {
            return (
                <>
                    {row.mensagem
                        ? <img src="/images/e-mail.png" width={20} />
                        : <></>
                    }
                </>
            )
        }

        return (
            <>
                <MDBRow md="12" style={{ marginBottom: 120 }}>

                    <MDBCol md="3">
                        <MDBCol md="12">
                            <div className="area-status-xml restantes">
                                <div style={{ display: "flex", margin: "auto" }}>
                                    <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                                        <img src="/images/adquirido.png" className="pointer hvr-buzz warning-buzz" onClick={() => this.obs.open_buy_chave = true}></img>
                                    </div>
                                    <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                                        <p className="topo-title-xml">{CaixaPostalStore.obs.credito_contratado.toLocaleString('pt-BR')}</p>
                                        <p className="fundo-title-xml">Total Adquirido</p>
                                    </div>
                                </div>
                            </div>
                        </MDBCol>
                        <MDBCol md="12">
                            <div className="area-status-xml usadas" >
                                <div style={{ display: "flex", margin: "auto" }}>
                                    <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                                        <img src="/images/usadas.png"></img>
                                    </div>
                                    <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                                        <p className="topo-title-xml">{CaixaPostalStore.obs.credito_usados.toLocaleString('pt-BR')}</p>
                                        <p className="fundo-title-xml">Chaves Utilizadas</p>
                                    </div>
                                </div>
                            </div>
                        </MDBCol>
                        <MDBCol md="12">
                            <div className="area-status-xml adquiradas">
                                <div style={{ display: "flex", margin: "auto" }}>
                                    <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                                        <img src="/images/restantes.png"></img>
                                    </div>
                                    <div style={{ textAlign: "center", width: "100%", margin: "auto" }}>
                                        <p className="topo-title-xml">{getRestante().toLocaleString('pt-BR')}</p>
                                        <p className="fundo-title-xml">Chaves Restantes</p>
                                    </div>
                                </div>
                            </div>
                        </MDBCol>
                    </MDBCol>

                    <MDBCol md="9">

                        <MDBRow>
                            <MDBCol md="12">
                                <FormGroup
                                    label="Selecione as Empresas:"
                                    labelFor="empresas"
                                >
                                    <div className="select-empresa-sitfis">
                                        <BootstrapTable data={select_empresas} selectRow={selectRowProp} options={options} search>
                                            <TableHeaderColumn dataField="cnpj_default" isKey={true} hidden width="1%">#</TableHeaderColumn>
                                            <TableHeaderColumn dataField="razao_social" width="40%">Razão Social</TableHeaderColumn>
                                            <TableHeaderColumn dataField="apelido" width="30%">Apelido</TableHeaderColumn>
                                            <TableHeaderColumn dataField="cnpj" width="20%">CNPJ</TableHeaderColumn>
                                            <TableHeaderColumn dataFormat={formatVisualizaMensagem} width="5%"></TableHeaderColumn>
                                        </BootstrapTable>
                                    </div>
                                </FormGroup>
                            </MDBCol>

                            <MDBCol md="12">
                                <MDBBtn
                                    className="btnDefault btnManifestar"
                                    onClick={() => this.handleSolicitaAssuntos()}
                                    style={{ float: "right" }}
                                >
                                    Solicitar
                                </MDBBtn>

                                <MDBBtn
                                    className="btnDefault btnBuscarNfe"
                                    onClick={() => this.handleClose()}
                                    style={{ float: "right", marginRight: 15 }}
                                >
                                    Cancelar
                                </MDBBtn>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>
                </MDBRow>

                <Dialog
                    isOpen={this.obs.open_buy_chave}
                    onClose={() => this.obs.open_buy_chave = false}
                    className="AlertUser"
                >
                    <h2 className="titleSEFAZ">Comprar Chaves</h2>

                    <FormGroup label="Quantidade">
                        <InputGroup
                            type="number"
                            value={(this.obs.quantidade)}
                            onChange={(e) => this.obs.quantidade = e.target.value}
                        />
                    </FormGroup>

                    <FormGroup>
                        <label className="bp3-label">Valor de cada Chave</label>
                        <IntlCurrencyInput
                            className="form-control"
                            value={0.24}
                            currency="BRL"
                            config={currencyConfig}
                            disabled
                        />
                    </FormGroup>

                    {this.thisValorCompra()}

                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button text="Cancelar" onClick={() => this.obs.open_buy_chave = false} />
                        <Button text="Confirmar" intent="primary" onClick={() => this.handleBuyChaves()} />
                    </div>
                </Dialog>

                <Alert
                    confirmButtonText="Cancelar"
                    isOpen={this.obs.pagamento_pix}
                    onConfirm={() => this.handleCancelPix()}
                    className="AlertUser"
                    intent="danger"
                >
                    <h2 className="titleSEFAZ">Pagar com Pix</h2>

                    <div style={{ textAlign: "center" }}>
                        <img src={CaixaPostalStore.obs.qrcode} width="200" />
                        <br />
                        <br />
                        <h6><b>Total: {numeral(this.obs.valor_total).format("0,0.00")}</b></h6>
                        <br />

                        <div style={{ display: "inline-flex" }}>
                            <h4 className="infoLabel">
                                Aguardando Pagamento: {" "}
                            </h4>
                            &nbsp;&nbsp;
                            <div className="lds-ellipsis" style={{ float: "none" }}>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>

                </Alert>

                <LoadingModal open={CaixaPostalStore.obs.loading} onClose={() => CaixaPostalStore.obs.loading = false} title={"Gerando QR Code"} />

                <Alert
                    confirmButtonText="Fechar"
                    isOpen={this.obs.open_erros_solicitacoes}
                    onConfirm={() => this.obs.open_erros_solicitacoes = false}
                    className="AlertUser"
                    intent="primary"
                >
                    <h2 className="titleSEFAZ">Erros ocorridos durante a Solicitação</h2>
                    <p style={{ marginBottom: 25, marginTop: -25 }}>
                        Para as empresas listadas abaixo, será necessário realizar novamente a solicitação.
                    </p>
                    <MDBCol md="12">
                        {erros.length &&
                            <div className="erroSitfis">
                                <BootstrapTable data={erros} hover>
                                    <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={formaterRazao} dataField='razao_social' width='30%'>Empresa</TableHeaderColumn>
                                    <TableHeaderColumn dataField='cnpj' width='20%'>CNPJ</TableHeaderColumn>
                                    <TableHeaderColumn dataField='erro' width='50%'>Erro</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        }
                    </MDBCol>
                </Alert>


            </>
        )
    }
}

